// The Conversations tab's list for a scope: one assistant or all of them, one market or all.
import type { ConversationFilter, ConversationSummary, OverviewScope, StorefrontApi } from './api';

export function loadConversations(
  api: StorefrontApi,
  scope: OverviewScope,
  filter: ConversationFilter,
  cursor?: string | null,
): Promise<{ items: ConversationSummary[]; next: string | null }> {
  return scope.store !== 'all' && scope.market === 'all'
    ? api.conversations(scope.store, filter, cursor)
    : api.conversationsIn(scope, filter, cursor);
}
